import { Pagination, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import clsx from 'clsx';
import Box from 'components/Box';
import { IApiHistoryCallerIdParams } from 'services/types/caller';
import styled from 'styled-components';
import { IUICallerIdHistoryItem } from 'types/customer';
import CallerContext from 'widgets/CallerId/context';
import CallerV2 from 'Calendar/CallerV2';
import { isCallerV2Enabled } from 'Calendar/CallerV2/feature-flag';
import { callerIdHistoryModalRef } from './CallerIdHistoryModal';
const columns: ColumnsType<IUICallerIdHistoryItem> = [
  {
    title: 'DATE',
    dataIndex: 'date',
    key: 'date',
  },

  {
    title: 'TIME',
    dataIndex: 'time',
    key: 'time',
  },
  {
    title: 'NAME',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'PHONE',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'CUSTOMER TYPE',
    dataIndex: 'customerType',
    key: 'customerType',
    width: '175px',
    render(value) {
      return <Box display='flex' justifyContent='center' alignItems='center'><CustomerType className={value}><span>{value}</span></CustomerType></Box>;
    },
  },
  {
    title: 'ACTION',
    key: 'action',
    width: '100px',
    render(value: IUICallerIdHistoryItem) {
      return <ActionButtons>
        <button onClick={() => {
          callerIdHistoryModalRef.current?.close();
          if (isCallerV2Enabled()) { CallerV2.open(); return; }
          CallerContext?.onSMS({ callerId: value.id, customerId: value.customerId, customerName: value.name, phone: value.phone });
        }} type='button' disabled={value.sentSms || value.booked} className={clsx('btn', 'btn-sms')}>
          <span>
            SMS
          </span>
        </button>
        <button onClick={() => {
          callerIdHistoryModalRef.current?.close();
          if (isCallerV2Enabled()) { CallerV2.open(); return; }
          CallerContext?.onBook({ callerId: value.id, customerId: value.customerId, customerName: value.name, phone: value.phone });
        }} type='button' disabled={value.booked} className={clsx('btn', value.booked ? 'btn-booked' : 'btn-book')}>
          <span>
            {value.booked ? 'Booked' : 'Book'}
          </span>
        </button>
      </ActionButtons>;
    },
  },
];
type Props = {
  dataSource: IUICallerIdHistoryItem[];
  loading?: boolean;
  totalItems: number;
  onChangePage: (page: number) => void;
  params: IApiHistoryCallerIdParams;
};
const CallerIdHistoryTable = ({ dataSource, loading, totalItems, onChangePage, params }: Props) => {

  return (
    <Box display='flex' flexDirection='column' alignSelf='stretch' gap='2'>
      <OverScrollTable>
        <TableStyled
          dataSource={dataSource || []}
          columns={columns as any}
          style={{ width: '100%' }}
          loading={loading}
          rowKey={'id'}
          pagination={false}
        />
      </OverScrollTable>
      <Box display='flex' justifyContent='end' alignSelf='stretch'>
        <Pagination
          total={totalItems || 0}
          pageSize={10}
          current={params?.page || 1}
          showSizeChanger={false}
          onChange={onChangePage}
        />
      </Box>
    </Box>
  );
};

export default CallerIdHistoryTable;

const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  button.btn {
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    border-radius: 4px;
    background: #148CF1;
    border: 1px solid #148CF1;
    &:active {
      opacity: 0.5;
    }
    span {
      color: #FFF;
      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    &.btn-sms {
      background: #fff;
      border: 1px solid #2D6772;
      span {
        color: #2D6772;
      }

      &:disabled {
        background: #fff;
        border: 1px solid #2D6772;
        opacity: 0.5;
        span {
          color: #2D6772;
        }
      }
    }
    &.btn-booked {
      background: #D4D7E4;
      border: 1px solid #D4D7E4;
      opacity: 0.5;
      span {
        color: #1D2129;
      }
    }
  }
`;

const OverScrollTable = styled.div`
  height: 65vh;
  overflow: auto;
  position: relative;
  .ant-table .ant-table-content th.ant-table-cell {
    position: sticky;
    top: 0;
    z-index: 1;
  }
  .ant-table-wrapper .ant-table.ant-table-empty .ant-table-tbody .ant-table-cell {
    border: none;
    .ant-empty-image {
      zoom: 1.5;
    }
  }
`;
const CustomerType = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: #EBFFF0;
  span {
    color: #00A140;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  &.new {
    background: #FFEFEB;
    span {
      color: #D2390E;
    }
  }
`;

const TableStyled = styled(Table)`
  background: #fff;
  .ant-table {
    .ant-table-container .ant-table-content {
      thead.ant-table-thead th.ant-table-cell {
        padding: 4px 8px;
        align-items: center;
        gap: 4px;
        align-self: stretch;
        border-right: 1px solid #F1F1F1;
        background: #1D2129;

        color: #FFF;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      tbody.ant-table-tbody tr:nth-child(even) td{
        background: #E8F3FF;
      }


    }
  }
`;